export default __webpack_public_path__ + "static/media/Zone 7.3b60228c.jpg";